/**
 * Scroller for search page to scroll back to the filter section.
 */
const searchForm = document.querySelector('.post-search.deepsea-form');

if (searchForm) {
  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.toString() !== '') {
    const masthead = document.getElementById('masthead');
    const mastheadHeight = masthead.getBoundingClientRect().height;
    const searchFormTop = searchForm.getBoundingClientRect().top;
    const scrollPos = searchFormTop - mastheadHeight;

    window.scrollTo({ top: scrollPos, behavior: 'smooth' });
  }
}
